// src/utils/seo/aboutSeo.js

import teamLogo from "../../../assets/teamLogo.jpg";

export const getAboutSEO = () => ({
    title:
        "Đinh Thị Mỹ Diệp - Chuyên gia bất động sản hàng đầu Việt Nam",

    description:
        "Tìm hiểu về Đinh Thị Mỹ Diệp – chuyên gia bất động sản giàu kinh nghiệm, mang đến giải pháp đầu tư, mua bán và cho thuê uy tín tại Việt Nam.",

    keywords:
        "Đinh Thị Mỹ Diệp, giới thiệu, bất động sản, đầu tư, mua bán, cho thuê",

    image: teamLogo,

    type: "website",

    url:
        typeof window !== "undefined"
            ? window.location.href
            : "https://vinhomesdemo.com/about",

    schema: {
        "@context": "https://schema.org",
        "@type": "Person",
        name: "Đinh Thị Mỹ Diệp",
        description:
            "Đinh Thị Mỹ Diệp là chuyên gia bất động sản giàu kinh nghiệm.",
    },
});